module.exports = __webpack_public_path__ + "img/andy_umana.788dc196.jpeg";